<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
  <li>
    <a [routerLink]="['/']">Home</a>
  </li>
  <li>Library Tasks List</li>

</ul>
<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong>Library Tasks List</strong>
      <span style="float: right">
        <button type="button" class="btn btn-sm btn-primary" (click)="createTask()"
          [appHasPermission]="{'Url': '/tasks/library/edit?goveva=true&email=', 'method':'put', 'menu': 'LibraryTask'}">
          <i class="fa fa-plus"></i>&nbsp;Create Tasks
        </button> &nbsp; &nbsp; &nbsp;
        <button type="button" class="btn btn-sm btn-primary" data-toggle="modal" data-target="#bulkUploadModal"
          [appHasPermission]="{'Url': '/tasks/library/edit?goveva=true&email=', 'method':'put', 'menu': 'LibraryTask'}">
          <i class="fa fa-upload"></i>&nbsp;Bulk Upload
        </button> &nbsp; &nbsp; &nbsp;
        <button type="button" class="btn btn-sm btn-primary"
          [appHasPermission]="{'Url': '/tasks/library/edit?goveva=true&email=', 'method':'put', 'menu': 'LibraryTask'}"
          data-toggle="modal" data-target="#configureSettingsDialog" (click)="getPeriodicTaskConfiguration()">
          <i class="fa fa-plus"></i>&nbsp;Configure Settings
        </button> &nbsp; &nbsp; &nbsp;
        <button type="button" class="btn btn-sm btn-primary pull-right" (click)="editReminderTask()"
          [appHasPermission]="{'Url': '/tasks/library/edit?goveva=true&email=', 'method':'put', 'menu': 'LibraryTask'}">
          <i class="fa fa-pencil"></i>&nbsp;Edit Reminder Frequency
        </button>

      </span>
    </span>
  </div>

  <div class="row">

    <div class="col-md-12" id="committeeTabContainer">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" (click)="onclickEventTask()" data-target="#eventBasedTaskDetails" data-toggle="tab"
            href="javascript: void(0);" role="tab" aria-selected="true">Event Based Tasks</a>
        </li>
        <li class="nav-item">
          <a class="nav-link " (click)="onclickPeriodicTask()" data-target="#periodicTaskTab" data-toggle="tab"
            href="javascript: void(0);" role="tab">Periodic Tasks</a>
        </li>
      </ul>

      <div class="tab-content">

        <div class="tab-pane active" id="eventBasedTaskDetails" role="tabcard">
          <section class="card">
            <!-- <div class="card-header">
                <span class="cat__core__title">
                  <strong>Event Based Task</strong>
                </span>
              </div> -->

            <!-- <button type="button" class="btn btn-info" >Simple collapsible</button> -->


            <section class="card search-box">
              <div class="card-header" (click)="toggleSearchCollapse()" style="cursor: pointer;">Modify Search <span
                  class="pull-right"><i class="fa fa-filter" aria-hidden="true"></i></span> </div>
              <div id="search-div" class="card-block" *ngIf="!isSearchCollapsed">
                <!-- Row 1: Labels for Radio Options and Dropdowns -->
                <div class="filter-row-labels filter-row-labels-event">
                  <div class="filter-label-item">
                    <label class="form-control-label">User defined / Pre defined</label>
                  </div>
                  <div class="filter-label-item">
                    <label class="form-control-label">Tag</label>
                  </div>
                  <div class="filter-label-item">
                    <label class="form-control-label">Emails</label>
                  </div>
                  <div class="filter-label-item">
                    <label class="form-control-label">Trigger ID</label>
                  </div>
                  <div class="filter-label-item">
                    <!-- Empty for button alignment -->
                  </div>
                </div>

                <!-- Row 2: All Radio Button Options, Dropdowns and Action Buttons in One Line -->
                <div class="filter-row-options-single filter-row-options-event">
                  <div class="filter-item-radio">
                    <div class="radio-options-group">
                      <div class="md-radio md-radio-inline">
                        <input id="IsPredefinedEventTaskYes" type="radio"
                          (click)="searchEventEnable()" name="TaskuserdefinedorPredefinedEventTask"
                          [(ngModel)]="searchParam.SearchtaskUserdefinedorPredefinedModelEventTask" value='true'
                          class="form-check-input">
                        <label for="IsPredefinedEventTaskYes">Pre defined</label>
                      </div>
                      <div class="md-radio md-radio-inline">
                        <input id="IsPredefinedEventTaskNo" type="radio"
                          (click)="searchEventEnable()" name="TaskuserdefinedorPredefinedEventTask"
                          [(ngModel)]="searchParam.SearchtaskUserdefinedorPredefinedModelEventTask" value='false'
                          class="form-check-input">
                        <label for="IsPredefinedEventTaskNo">User defined</label>
                      </div>
                    </div>
                  </div>
                  <div class="filter-item-dropdown">
                    <div class="form-group">
                      <select id="groupdropdown" [(ngModel)]="searchParam.groupname" class="form-control select"
                        (change)="getSelectedGroupID($event)">
                        <option [value]=null>Select</option>
                        <option *ngFor="let group of groupTypes" value={{group._id}}>
                          {{group.GroupName}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="filter-item-radio">
                    <div class="radio-options-group">
                      <div class="md-radio md-radio-inline">
                        <input id="IsEmailSendYes" type="radio" (click)="enableSearchButton()"
                          name="IsEmailSend" [(ngModel)]="searchParam.IsEmailSend" [value]='true'
                          class="form-check-input">
                        <label for="IsEmailSendYes">ON</label>
                      </div>
                      <div class="md-radio md-radio-inline">
                        <input id="IsEmailSendNo" type="radio" (click)="enableSearchButton()"
                          name="IsEmailSend" [(ngModel)]="searchParam.IsEmailSend" [value]='false'
                          class="form-check-input">
                        <label for="IsEmailSendNo">OFF</label>
                      </div>
                    </div>
                  </div>
                  <div class="filter-item-dropdown">
                    <div class="form-group">
                      <select id="triggerdropdown" [(ngModel)]="searchParam.triggerId" class="form-control select"
                        (click)="enableSearchButton()">
                        <option [value]=null>Select</option>
                        <option *ngFor="let taskTriggerType of taskTriggerTypes" value={{taskTriggerType._id}}>
                          {{taskTriggerType.Name}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="filter-actions">
                    <button type="button" [disabled]="response" (click)="showTasksBySearchDataEventTask(searchParam)"
                      class="btn btn-sm btn-primary" title="search">
                      <em class="fa fa-search"></em> &nbsp; Search
                    </button>
                    <button type="button" class="btn btn-sm btn-default btn-clear" (click)="showAllEventTasks()" title="refresh">
                      <em class="fa fa-refresh"></em> &nbsp; Clear
                    </button>
                  </div>
                </div>
              </div>
            </section>
            <!-- <pre>{{ libraryEventBasedTaskList | json }}</pre> -->
            <div class="card-block  datatable-card-block">
              <div class="row">
                <div class="col-md-12">

                  <div class="dt-toolbar">
                    <form [formGroup]="activateTasksForm" class="form-inline well shiftToTable">
                      <div class="form-group">
                        <label>Task Particulars:<span _ngcontent-c2="" style="color: red;">*</span></label>
                        <input [formControl]="activateTasksForm.controls['TaskParticulars']" data-toggle="tooltip"
                          data-placement="top" title="Enter Task particulars." class="form-control task-search">
                        <!-- <div *ngIf="activateTasksForm.controls['TaskParticulars'].hasError('required') && activateTasksForm.controls['TaskParticulars'].touched"
                            class="form-control-error-custom">
                            Task particulars is required.
                          </div> -->
                      </div>
                      <button id="btnactivateTasks" type="button" class="btn btn-sm btn-primary"
                        (click)="activateTasks()" [disabled]="!IsSelectedTasks || !activateTasksForm.valid"
                        [appHasPermission]="{'Url': '/tasks/library/edit?goveva=true&email=', 'method':'put', 'menu': 'LibraryTask'}"><i
                          class="fa fa-check"></i>&nbsp;Activate</button>

                      <button (click)="showaddTasktoProcessDialog()" type="button" data-toggle="modal"
                        data-target="#addtasktoprocessDialogEventTask" class="btn btn-sm btn-primary"
                        [disabled]="!addToProcessEventTask"
                        [appHasPermission]="{'Url': '/tasks/library/edit?goveva=true&email=', 'method':'put', 'menu': 'LibraryTask'}"><i
                          class="fa fa-save"></i>&nbsp;Add to Process</button>

                      <button type="button" class="btn btn-sm btn-danger"
                        (click)="bulkDeleteSelectedTasks('event')" [disabled]="!IsSelectedTasks || isBulkDeleting"
                        [appHasPermission]="{'Url': '/tasks/library/edit?goveva=true&email=', 'method':'put', 'menu': 'LibraryTask'}">
                        <i class="icmn-bin"></i>&nbsp;Delete Selected
                      </button>

                    </form>
                  </div>

                  <div class="dt-toolbar" *ngIf="isCheckerRole && searchPeriodicParam.ApproveStatus !== null">
                    <form [formGroup]="activateTasksForm" class="form-inline well shiftToTable">

                      <button id="btnactivateTasks" type="button" class="btn btn-sm btn-primary"
                        (click)="approveMultipleTasksConfirmation('event')" [disabled]="!IsSelectedTasks"
                        [appHasPermission]="{'Url': '/tasks/library/edit?goveva=true&email=', 'method':'put', 'menu': 'LibraryTask'}">
                        <em class="fa fa-check"></em>Approve/Reject</button>
                    </form>
                  </div>

                  <div class="table-responsive" style="position: relative;">
                    <!-- Loader overlay for Event Based Tasks -->
                    <div class="library-task-loader-overlay" *ngIf="isLoading || isSearchLoadingEvent">
                      <div class="library-task-loader-container">
                        <img src="assets/images/DigiCompany_loader.png" class="library-task-spinner" alt="Loading..." />
                      </div>
                    </div>
                    <div class="company-task-custom-style">
                      <table datatable [dtOptions]="dtOptionsEventBasedTask" [dtTrigger]="dtTriggerEventBasedTask"
                        class="table table-hover compact cell-border nowrap stripe dataTable sticky-header"
                        id="eventLiberyTaskTable" style="cursor: pointer; width: -webkit-fill-available !important;">
                        <thead style="position: sticky; top: 0; z-index: 1; background: white;">
                          <tr>
                            <th style="display:none">Tasks ID</th>

                            <th>
                              <div class="md-checkbox">
                                <input id="selectcheckboxallEventTask" class="md-checkbox" type="checkbox"
                                  [(ngModel)]="selectedAllEventTask" (change)="checkIfAllSelectedEvent()" />
                                <label for="selectcheckboxallEventTask">&nbsp;</label>
                              </div>
                            </th>
                            <th class="companyTask-list-column">Tasks Name </th>
                            <th>Tasks Description </th>
                            <th class="companyTask-list-column">Global/Company Specific </th>
                            <th class="companyTask-list-column">Tag</th>

                            <th class="companyTask-list-action" style="width: 15%">Action</th>
                            <th class="companyTask-list-action" style="display:none">Meeting Type</th>
                            <th class="companyTask-list-action" style="display:none">Assigned To</th>
                            <th class="companyTask-list-action" style="display:none">Due Date (in days)</th>
                            <th class="companyTask-list-action" style="display:none">Trigger Id</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr *ngFor="let companytask of libraryEventBasedTaskList; let count=index"
                            [ngClass]="{'inActiveCompanyTasks':companytask.IsActive==false,'activeCompanyTasks':companytask.IsActive==true}">
                            <td style="display: none">{{companytask.TaskID}}</td>

                            <td>
                              <div class="md-checkbox">
                                <input id="selectcheckboxForEvent{{count +1 }}" type="checkbox"
                                  [(ngModel)]="companytask.SelectedTask" (change)="selectcheckboxForEvent();"
                                  (change)="checkselectedEvent($event,companytask.IsActive, companytask.TriggerType, count);">
                                <label for="selectcheckboxForEvent{{count +1 }}">&nbsp;</label>
                              </div>
                            </td>
                            <!-- <td>{{count+1}}</td> -->
                            <td class="companyTask-list-column" style="white-space: normal !important;">
                              {{companytask.TaskName }}</td>
                            <td style="white-space: normal !important;">{{companytask.TaskDescription }}</td>
                            <td class="companyTask-list-column" style="white-space: normal !important;"><span
                                *ngIf="companytask.IsGlobal">Global</span> <span *ngIf="!companytask.IsGlobal">Company
                                Specific
                              </span></td>
                            <td class="companyTask-list-column">{{companytask.GroupName }}</td>

                            <td class="companyTask-list-action" style="width: 15%">
                              <button *ngIf="companytask.IsActive===true" type="button" class="btn-sm btn btn-warning"
                                (click)="EditEventBasedTask(companytask.ID)"
                                [appHasPermission]="{'Url': '/tasks/library/edit?goveva=true&email=', 'method':'put', 'menu': 'LibraryTask'}">
                                <span class="fa fa-pencil"></span>
                              </button>
                              <button *ngIf="isCheckerRole && searchPeriodicParam.ApproveStatus !== null" type="button" class="btn-sm btn btn-info"
                                (click)="approveTaskStatusConfirmation(companytask.ID, companytask.type)"
                                [appHasPermission]="{'Url': '/tasks/library/review?goveva=true&email=', 'method':'get', 'menu': 'LibraryTask'}">
                                <span class="fa fa-check-circle"></span>
                              </button>
                              <button *ngIf="companytask.IsPredefined===false" type="button"
                                class="btn-sm btn btn-danger" (click)="deleteConfirmationEventBasedTask(companytask.ID)"
                                [appHasPermission]="{'Url': '/tasks/library/edit?goveva=true&email=', 'method':'put', 'menu': 'LibraryTask'}">
                                <span class="icmn-bin"></span>
                              </button>
                              <button type="button" (click)="historyDetailsById(companytask.ID)"
                                class="btn-sm btn btn-warning" title="History">
                                <span class="icmn-history"></span>
                              </button>
                              <button type="button" class="btn-sm btn btn-primary"
                                (click)="copyTaskLink(companytask.ID)" title="Copy Task Link">
                                <span class="fa fa-copy"></span>
                              </button>

                            </td>
                            <td class="companyTask-list-column" style="display:none">{{companytask.MeetingType }}</td>
                            <td class="companyTask-list-column" style="display:none">
                              {{companytask.AssignedUserName}}
                              <!-- {{getAssignTo(companytask.AssignedTo)}}</td> -->
                            <td class="companyTask-list-column" style="display:none">{{companytask.CompletionDays }}
                            </td>
                            <td class="companyTask-list-column" style="display:none">{{companytask.TriggerName }}</td>
                          </tr>
                        </tbody>

                      </table>
                    </div>
                  </div>

                </div>
              </div>
            </div>




          </section>
        </div>

        <div class="tab-pane " id="periodicTaskTab" role="tabcard">
          <section class="card">
            <!--  header: Periodic -->
            <!-- <div class="card-header">
                <span class="cat__core__title">
                  <strong>Periodic Based Task</strong>
                </span>
              </div> -->

            <!-- Search Filter : Periodic -->
            <section class="card search-box">
              <div class="card-header" (click)="toggleSearchCollapsePeriodic()" style="cursor: pointer;">Modify Search <span
                  class="pull-right"><i class="fa fa-filter" aria-hidden="true"></i></span> </div>
              <div class="card-block" *ngIf="!isSearchCollapsedPeriodic">
                <!-- Row 1: Labels for Dropdowns -->
                <div class="filter-row-labels filter-row-labels-periodic">
                  <div class="filter-label-item">
                    <label class="form-control-label">Tag</label>
                  </div>
                  <div class="filter-label-item">
                    <label class="form-control-label">Task Status</label>
                  </div>
                  <div class="filter-label-item">
                    <label class="form-control-label">Trigger ID</label>
                  </div>
                  <div class="filter-label-item">
                    <!-- Empty for alignment -->
                  </div>
                </div>

                <!-- Row 2: All Dropdowns in One Line -->
                <div class="filter-row-dropdowns-periodic">
                  <div class="filter-item-dropdown">
                    <div class="form-group">
                      <select id="groupdropdown" [(ngModel)]="searchPeriodicParam.groupname" class="form-control select"
                        (change)="getSelectedGroupID($event)">
                        <option [value]=null>Select</option>
                        <option *ngFor="let group of groupTypes" value={{group._id}}>
                          {{group.GroupName}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="filter-item-dropdown">
                    <div class="form-group">
                      <select id="taskStatusdropdown" [(ngModel)]="searchPeriodicParam.selcettaskname"
                        [formControl]="activateTasksForm.controls['TaskStatus']" class="form-control select"
                        (change)="getSelectedTaskStatus($event)">
                        <option [value]="null"> All </option>
                        <option value="Active">Active</option>
                        <option value="InActive">Inactive</option>
                      </select>
                    </div>
                  </div>
                  <div class="filter-item-dropdown">
                    <div class="form-group">
                      <select id="triggerdropdownPeriodic" [(ngModel)]="searchPeriodicParam.triggerId" class="form-control select"
                        (click)="isEnableButtonSearch()">
                        <option [value]=null>Select</option>
                        <option *ngFor="let taskTriggerType of taskTriggerTypes" value={{taskTriggerType._id}}>
                          {{taskTriggerType.Name}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="filter-label-item">
                    <!-- Empty for alignment -->
                  </div>
                </div>

                <!-- Row 3: Labels for Radio Options and Buttons -->
                <div class="filter-row-labels filter-row-labels-periodic">
                  <div class="filter-label-item">
                    <label class="form-control-label">User defined / Pre defined</label>
                  </div>
                  <div class="filter-label-item"   style="margin-left: 98px;">
                    <label class="form-control-label">Emails</label>
                  </div>
                  <div class="filter-label-item">
                    <!-- Empty for button alignment -->
                  </div>
                </div>

                <!-- Row 4: Radio Options and Action Buttons in One Line -->
                <div class="filter-row-options-single filter-row-options-periodic">
                  <div class="filter-item-radio">
                    <div class="radio-options-group">
                      <div class="md-radio md-radio-inline">
                        <input id="IsPrePeriodicTaskYes" type="radio"
                          name="TaskuserPredefinedPeriodicTask" (click)="periodicSerchDefindTask()"
                          [(ngModel)]="searchPeriodicParam.SearchtaskUserdefinedorPredefinedModelPeriodicTask"
                          [value]='true' class="form-check-input">
                        <label for="IsPrePeriodicTaskYes">Pre defined</label>
                      </div>
                      <div class="md-radio md-radio-inline">
                        <input id="IsPrePeriodicTaskNo" type="radio"
                          name="TaskuserPredefinedPeriodicTask" (click)="periodicSerchDefindTask()"
                          [(ngModel)]="searchPeriodicParam.SearchtaskUserdefinedorPredefinedModelPeriodicTask"
                          [value]='false' class="form-check-input">
                        <label for="IsPrePeriodicTaskNo">User defined</label>
                      </div>
                    </div>
                  </div>
                  <div class="filter-item-radio">
                    <div class="radio-options-group">
                      <div class="md-radio md-radio-inline">
                        <input id="IsEmailSendYesPeriodic" type="radio"
                          (click)="isEnableButtonSearch()" name="IsEmailSendNoPeriodicTask"
                          [(ngModel)]="searchPeriodicParam.IsEmailSend" [value]='true'
                          class="form-check-input">
                        <label for="IsEmailSendYesPeriodic">ON</label>
                      </div>
                      <div class="md-radio md-radio-inline">
                        <input id="IsEmailSendNoPeriodic" type="radio"
                          (click)="isEnableButtonSearch()" name="IsEmailSendNoPeriodicTask"
                          [(ngModel)]="searchPeriodicParam.IsEmailSend" [value]='false'
                          class="form-check-input">
                        <label for="IsEmailSendNoPeriodic">OFF</label>
                      </div>
                    </div>
                  </div>
                  <div class="filter-actions">
                    <button type="button" [disabled]="response"
                      (click)="showTasksBySearchDataPeriodic(searchPeriodicParam)" class="btn btn-sm btn-primary"
                      title="search">
                      <em class="fa fa-search"></em> &nbsp; Search
                    </button>
                    <button type="button" [disabled]="response" class="btn btn-sm btn-default btn-clear"
                      (click)="showAllPeriodicTasks()" title="refresh">
                      <em class="fa fa-refresh"></em> &nbsp; Clear
                    </button>
                  </div>
                </div>
              </div>
            </section>

            <div class="card-block  datatable-card-block">
              <div class="row">
                <div class="col-md-12">
                  <div class="dt-toolbar">
                    <form class=" form-inline well shiftToTable2">

                      <button id="btnDeselectTasks" type="button" class="btn btn-sm btn-primary"
                        (click)="deselectTasksPerodicTask()"
                        [disabled]="!(deactivatedTaskCount >= 1) || ((deactivatedTaskCount >= 1) && (activatedTaskCount >= 1))"
                        [appHasPermission]="{'Url': '/tasks/library/edit?goveva=true&email=', 'method':'put', 'menu': 'LibraryTask'}"><i
                          class="fa fa-times"></i>&nbsp;Deactivate Periodic Tasks</button>
                      &nbsp;&nbsp;&nbsp;
                      <button id="btnSelectTasks" type="button" class="btn btn-sm btn-primary" (click)="selectTasks()"
                        [disabled]="!(activatedTaskCount >= 1) || ((deactivatedTaskCount >= 1) && (activatedTaskCount >= 1))"
                        [appHasPermission]="{'Url': '/tasks/library/edit?goveva=true&email=', 'method':'put', 'menu': 'LibraryTask'}"><i
                          class="fa fa-check"></i>&nbsp;Reactivate Periodic Tasks</button>

                      <button type="button" class="btn btn-sm btn-danger"
                        (click)="bulkDeleteSelectedTasks('periodic')" [disabled]="!IsSelectedTasks || isBulkDeleting"
                        [appHasPermission]="{'Url': '/tasks/library/edit?goveva=true&email=', 'method':'put', 'menu': 'LibraryTask'}">
                        <i class="icmn-bin"></i>&nbsp;Delete Selected
                      </button>

                      <span *ngIf="(deactivatedTaskCount >= 1) && (activatedTaskCount >= 1)" class="toolbarMessage"
                        style=" width: 100%;" data-toggle="tooltip" data-placement="top"
                        title="Both Active and Inactive task is selected."><i
                          class="toolbarMessageIcon fa fa-exclamation-circle" aria-hidden="true"></i>
                      </span>
                    </form>
                  </div>
                  <div class="dt-toolbar" *ngIf="isCheckerRole && searchPeriodicParam.ApproveStatus !== null">
                    <form [formGroup]="activateTasksForm" class="form-inline well shiftToTable">
                      <button id="btnactivateTasks" type="button" class="btn btn-sm btn-primary"
                        (click)="approveMultipleTasksConfirmation('periodic')" [disabled]="!IsSelectedTasks"
                        [appHasPermission]="{'Url': '/tasks/library/edit?goveva=true&email=', 'method':'put', 'menu': 'LibraryTask'}"><i
                          class="fa fa-check"></i>Approve/Reject</button>
                    </form>
                  </div>
                  <!--Periodic DataTable  -->
                  <div class="margin-bottom-50">
                    <div class="table-responsive" style="position: relative;">
                      <!-- Loader overlay for Periodic Tasks -->
                      <div class="library-task-loader-overlay" *ngIf="isLoading || isSearchLoadingPeriodic">
                        <div class="library-task-loader-container">
                          <img src="assets/images/DigiCompany_loader.png" class="library-task-spinner" alt="Loading..." />
                        </div>
                      </div>
                      <div class="company-task-custom-style">
                        <table datatable [dtOptions]="dtOptionsforPeriodicTask" [dtTrigger]="dtTriggerforPeriodicTask"
                          id="PeriodicTaskDataTable"
                          class="table table-hover compact cell-border nowrap stripe dataTable sticky-header"
                          style="cursor: pointer; width: -webkit-fill-available !important;">
                          <thead style="position: sticky; top: 0; z-index: 1; background: white;">
                            <tr>
                              <th style="display:none">Tasks ID</th>

                              <th>
                                <div class="md-checkbox">
                                  <input id="checkboxForPeriodicTask" class="md-checkbox" type="checkbox"
                                    [(ngModel)]="checkAllPeriodicTask" (change)="selectAllPeriodicTask($event);" />
                                  <label for="checkboxForPeriodicTask">&nbsp;</label>
                                </div>
                              </th>
                              <th class="companyTask-list-column">Tasks Name </th>
                              <th>Tasks Description </th>
                              <th class="companyTask-list-column">Global/Company Specific </th>
                              <th class="companyTask-list-column">Tag</th>

                              <th class="companyTask-list-action" style="width: 15%;">Action</th>
                              <th class="companyTask-list-action" style="display:none">Meeting Type</th>
                              <th class="companyTask-list-action" style="display:none">Assigned To</th>
                              <th class="companyTask-list-action" style="display:none">Due Date (in days)</th>
                              <th class="companyTask-list-action" style="display:none"> Trigger Id</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr *ngFor="let periodictask of periodicTaskList; let count=index"
                              [ngClass]="{'inActiveCompanyTasks':periodictask.IsActive==false,'activeCompanyTasks':periodictask.IsActive==true}">
                              <td style="display: none">{{periodictask.TaskID}}</td>

                              <td>
                                <div class="md-checkbox">
                                  <input id="selectedAllPeriodic{{count +1 }}" type="checkbox"
                                    [(ngModel)]="periodictask.SelectedTask"
                                    (change)="checkselected($event,periodictask.IsActive);">
                                  <label for="selectedAllPeriodic{{count +1 }}">&nbsp;</label>
                                </div>
                              </td>

                              <td class="companyTask-list-column" style="white-space: normal !important;">
                                {{periodictask.TaskName }}</td>
                              <td style="white-space: normal !important;">{{periodictask.TaskDescription }}</td>
                              <td class="companyTask-list-column" style="white-space: normal !important;"><span
                                  *ngIf="periodictask.IsGlobal">Global</span> <span
                                  *ngIf="!periodictask.IsGlobal">Company
                                  Specific
                                </span></td>
                              <td class="companyTask-list-column">{{periodictask.GroupName }}</td>

                              <td class="companyTask-list-action" style="width: 15%;">

                                <button *ngIf="periodictask.IsActive===true" type="button"
                                  class="btn-sm btn btn-warning" (click)="EditPeriodicBasedTask(periodictask.ID)"
                                  [appHasPermission]="{'Url': '/tasks/library/edit?goveva=true&email=', 'method':'put', 'menu': 'LibraryTask'}">
                                  <span class="fa fa-pencil"></span>
                                </button>
                                <button *ngIf="isCheckerRole && searchPeriodicParam.ApproveStatus !== null" type="button" class="btn-sm btn btn-info"
                                  (click)="approveTaskStatusConfirmation(periodictask.ID, periodictask.type)"
                                  [appHasPermission]="{'Url': '/tasks/library/review?goveva=true&email=', 'method':'get', 'menu': 'LibraryTask'}">
                                  <span class="fa fa-check-circle"></span>
                                </button>
                                <button *ngIf="periodictask.IsPredefined===false" type="button"
                                  class="btn-sm btn btn-danger"
                                  (click)="deleteConfirmationPeriodicBasedTask(periodictask.ID)"
                                  [appHasPermission]="{'Url': '/tasks/library/edit?goveva=true&email=', 'method':'put', 'menu': 'LibraryTask'}">
                                  <span class="icmn-bin"></span>
                                </button>
                                <button type="button" (click)="historyDetailsById(periodictask.ID)"
                                  class="btn-sm btn btn-warning" title="History">
                                  <span class="icmn-history"></span>
                                </button>
                                <button type="button" class="btn-sm btn btn-primary"
                                  (click)="copyTaskLink(periodictask.ID)" title="Copy Task Link">
                                  <span class="fa fa-copy"></span>
                                </button>

                              </td>
                              <td style="display:none">{{periodictask.MeetingType }}</td>
                              <td style="display:none">
                                <!-- {{ getAssignTo(periodictask.AssignedTo) }} -->
                                {{ periodictask.AssignedUserName }}
                              </td>
                              <td style="display:none">{{periodictask.CompletionDays }}</td>
                              <td style="display:none">{{periodictask.TriggerName }}</td>
                            </tr>
                          </tbody>

                        </table>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </section>
        </div>

        <div class="modal fade modal-size-medium" id="addtasktoprocessDialogEventTask" tabindex="-1" role="dialog"
          aria-labelledby="" aria-hidden="true">
          <div class="modal-dialog">
            <form [formGroup]="activateTasksForm" class="well">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="myModalLabel">process</h5>
                  <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div class="modal-body">

                  <div class="row">

                    <div class="col-md-6">
                      <label class="form-control-label" for="l0"> (Pre defined / User defined)
                      </label>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">

                        <div class="md-radio md-radio-inline">
                          <input id="IsPreDefined" type="radio"
                            [formControl]="activateTasksForm.controls['IsPredefinedorUserdefined']"
                            style="position:absolute" name="IsPredefinedorUserdefined" value="Predefined"
                            (click)="CheckProcessType('Predefined')" class="form-check-input">
                          <label for="IsPreDefined">Pre defined</label>
                        </div>
                        <div class="md-radio md-radio-inline">
                          <input id="IsUserDefined" type="radio"
                            [formControl]="activateTasksForm.controls['IsPredefinedorUserdefined']"
                            style="position:absolute" name="IsPredefinedorUserdefined" value="Userdefined"
                            (click)="CheckProcessType('Userdefined')" class="form-check-input">
                          <label for="IsUserDefined">User defined</label>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-control-label" for="l0">Select Process
                        <span _ngcontent-c2="" style="color: red;">*</span>
                      </label>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <select [formControl]="activateTasksForm.controls['ProcessID']" class="form-control select">
                          <option value=""> Select </option>
                          <option *ngFor="let process of processes" value={{process._id}}>
                            {{process.ProcessName}}
                          </option>
                        </select>
                        <div
                          *ngIf="activateTasksForm.controls['ProcessID'].hasError('required') && activateTasksForm.controls['ProcessID'].touched"
                          class="form-control-error-custom">
                          Process is required.
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
                <div class="modal-footer">

                  <button id="btnsaveTasktoProcess" type="button" class="btn btn-sm btn-primary" data-dismiss="modal"
                    [disabled]='!activateTasksForm.valid || disabledOnclick' (click)="addTaskstoProcess()"><i
                      class="fa fa-save"></i>&nbsp;Save
                  </button>

                  <button type="button" class="btn btn-sm" data-dismiss="modal"> <i
                      class="fa fa-times"></i>&nbsp;Close</button>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="modal fade" id="confirmationEventTask" tabindex="-1" role="dialog" aria-labelledby=""
          aria-hidden="true" style="top: 50px;">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="myModalLabelForDelete">
                  <i class="fa fa-question-circle-o mr-2"></i>Confirm
                </h5>
                <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                  <i class="fa fa-times"></i>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-sm-12">
                    Are you sure you want to delete this Task?
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-danger" (click)="deleteTask()">
                  <i class="fa fa-check"></i>&nbsp;Yes
                </button>
                <button type="button" class="btn btn-sm" data-dismiss="modal">
                  <i class="fa fa-times"></i>&nbsp;No
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade modal-size-medium" id="configureSettingsDialog" tabindex="-1" role="dialog"
          aria-labelledby="" aria-hidden="true">
          <div class="modal-dialog">
            <form [formGroup]="taskConfigurationForm" class="well">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="myModalLabel">Configuration</h5>
                  <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div class="modal-body">

                  <!-- <div class="row">
  
                      <div class="col-md-6">
                        <label class="form-control-label" for="l0"> (Pre defined / User defined)
                        </label>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
  
                          <div class="md-radio md-radio-inline">
                            <input id="IsPreDefined" type="radio" [formControl]="activateTasksForm.controls['IsPredefinedorUserdefined']" style="position:absolute"
                              name="IsPredefinedorUserdefined" value="Predefined" (click)="CheckProcessType('Predefined')" class="form-check-input">
                            <label for="IsPreDefined">Pre defined</label>
                          </div>
                          <div class="md-radio md-radio-inline">
                            <input id="IsUserDefined" type="radio" [formControl]="activateTasksForm.controls['IsPredefinedorUserdefined']" style="position:absolute"
                              name="IsPredefinedorUserdefined" value="Userdefined" (click)="CheckProcessType('Userdefined')"
                              class="form-check-input">
                            <label for="IsUserDefined">User defined</label>
                          </div>
  
                        </div>
                      </div>
                    </div> -->
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-control-label" for="l0">Select Default Assigned User
                        <span _ngcontent-c2="" style="color: red;">*</span>
                      </label>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <select [formControl]="taskConfigurationForm.controls['UserId']" class="form-control select"
                          (change)="selectedUserChange()">
                          <option value=""> Select </option>
                          <option *ngFor="let user of assignedusers" value={{user._id}}>
                            {{user.FirstName + " "+ user.LastName}}
                          </option>
                        </select>
                        <div
                          *ngIf="taskConfigurationForm.controls['UserId'].hasError('required') && taskConfigurationForm.controls['UserId'].touched"
                          class="form-control-error-custom">
                          User is required.
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
                <div class="modal-footer">

                  <button id="btnsaveTasktoProcess" type="button" class="btn btn-sm btn-primary"
                    [disabled]='!taskConfigurationForm.valid || disabledOnclick'
                    (click)="addPeriodicTaskConfiguration()"><i class="fa fa-save"></i>&nbsp;Save </button>

                  <button type="button" class="btn btn-sm" data-dismiss="modal"> <i
                      class="fa fa-times"></i>&nbsp;Close</button>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="modal" id="historyModel" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
          aria-labelledby="" aria-hidden="true">
          <div class="modal-dialog  modal-xl" role="document" style="max-width: 100% !important;">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="myModalLabelForDeletion">
                  <span class="icmn-history" style="margin-right: 10px;"></span>History
                </h5>
                <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                  <i class="fa fa-times"></i>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-sm-12">

                    <table datatable [dtOptions]="dtDetailsHistory" [dtTrigger]="dtDetailsTrigger"
                      class="table table-hover compact cell-border nowrap stripe sticky-header" id="Historytable"
                      style="cursor: pointer;">
                      <thead style="position: sticky; top: 0; z-index: 1; background: white;">
                        <tr>
                          <th style="min-width:150px;">Operation Type</th>
                          <th style="min-width:170px;">Operation Date and Time</th>
                          <th style="min-width:150px;">Created By</th>
                          <th style="min-width:150px;">Ip Address</th>
                          <th style="min-width:150px;">Tasks Name</th>
                          <th style="min-width:150px;">Tasks Description</th>
                          <th style="min-width:150px;">Group</th>
                          <th style="min-width:200px;">Meeting Type</th>
                          <th style="min-width:200px;">Reminder Days</th>
                          <th style="min-width:200px;">Reminder Period</th>
                          <th style="min-width:200px;">Escalation Days</th>
                          <th style="min-width:200px;">Level2 Escalation Days</th>
                          <th style="min-width:200px;">Completion Days</th>
                          <th style="min-width:200px;">Trigger Type</th>
                          <th style="min-width:150px;">Trigger ID</th>
                          <th style="min-width:150px;">Date Option</th>
                          <th style="min-width:150px;">Reminder Period Level1</th>
                          <th style="min-width:150px;">Reminder Period Level2</th>
                          <th style="min-width:150px;">Email Contents</th>
                          <th style="min-width:150px;">Remarks</th>
                          <th style="min-width:150px;">Risk Type</th>
                          <th style="min-width:150px;">Policy Type</th>
                          <th style="min-width:150px;">PreConsequences</th>
                          <th style="min-width:150px;">UserConsequences</th>
                          <th style="min-width:150px;">End Date</th>
                          <th style="min-width:150px;">Assigned To</th>
                          <th style="min-width:150px;">Responsible User</th>
                          <th style="min-width:150px;">Escalation1 of Assigned To</th>
                          <th style="min-width:150px;">Escalation2 of Assigned To</th>
                          <th style="min-width:150px;">Escalation1 of Responsible User</th>
                          <th style="min-width:150px;">Escalation2 of Responsible User</th>
                          <th style="min-width:150px;">Collegues</th>
                          <th style="min-width:150px;">IsGlobal</th>
                          <th style="min-width:150px;">Trigger Start Date</th>
                          <th style="min-width:150px;">Default Assigned To</th>
                          <th style="min-width:150px;">Fixed Date</th>
                          <th style="min-width:150px;">Approved</th>
                          <th style="min-width:150px;">Tasks Reject Comment</th>
                          <th style="min-width:150px;">Modified Date and Time</th>
                          <th style="min-width:150px;">Modified By</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let History of detailsHistory;" style="line-height: 25px;">
                          <td style="min-width:150px;" tabindex="1">{{History.o === 'u' ? 'Update' : 'Insert'}}</td>
                          <td style="min-width:170px;" tabindex="1">{{History.t | date : "dd-MM-y hh:mm a"}}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.CreatedByUserName }}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.d.IPAddress }}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.d.TaskName }}</td>
                          <td style="min-width:150px;">{{History.d.TaskDescription }}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.groupName}}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.meetingTypeName}} </td>
                          <td style="min-width:200px;" tabindex="1">{{History.d.ReminderDays }}</td>
                          <td style="min-width:200px;">{{History.d.ReminderPeriod}}</td>
                          <td style="min-width:200px;">{{History.d.EscalationDays}}</td>
                          <td style="min-width:200px;">{{History.d.Level2EscalationDays}}</td>
                          <td style="min-width:200px;">{{History.d.CompletionDays}}</td>
                          <td style="min-width:200px;">{{ History.d.TriggerType == 1 ? 'Event' : 'Periodic'}}</td>
                          <td style="min-width:200px;">{{History.triggerTypeName }}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.d.DateOption}}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.d.ReminderPeriodLevel1 }}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.d.ReminderPeriodLevel2 }}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.d.EmailContents}}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.Remarks}}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.d.RiskType == 1 ? 'High' :
                            (History.d.RiskType == 2 ? 'Medium' : (History.d.RiskType == 3 ? 'Low' : '') )}}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.d.PolicyType == 1 ? 'Statutory' :
                            (History.d.PolicyType == 2 ? 'Internal' : '') }}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.d.PreConsequences}}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.d.UserConsequences}}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.d.EndDate | date : "dd-MM-y"}}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.AssignedToName}}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.ResponsibleUserName}}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.Escalation1AssignedName}}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.Escalation2AssignedName}}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.Escalation1ResponsibleName}}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.Escalation2ResponsibleName}}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.CollegueName}}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.d.Global == true ? 'Yes': 'No'}}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.d.TriggerStartDate | date : "dd-MM-y"}}
                          </td>
                          <td style="min-width:150px;" tabindex="1">{{History.d.DefaultAssignedToName}}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.d.FixedDate | date : "dd-MM-y"}}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.d.isApproved == true ? 'Yes': 'No'}}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.d.taskRejectComment}}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.d.ModifiedDate | date : "dd-MM-y hh:mm
                            a"}}</td>
                          <td style="min-width:150px;" tabindex="1">{{History.ModifiedBy}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="modal-footer">

                <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                  <i class="fa fa-times"></i>&nbsp;Ok</button>
              </div>
            </div>
          </div>
        </div>

       <div class="modal fade" id="approveTaskStatusDialog" tabindex="-1" role="dialog" aria-labelledby=""
          aria-hidden="true" style="top: 50px;">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="myModalLabelForDelete">
                  <i class="fa fa-question-circle-o mr-2"></i>Confirm
                </h5>
                <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                  <i class="fa fa-times"></i>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-sm-6">
                    Are you sure you want to approve/reject this Task?
                  </div>
                  <div class="col-sm-6">
                    <div class="input-group" style="display: unset;">
                      <div class="md-radio md-radio-inline">
                        <input id="approveYes" type="radio" style="position:absolute" name="approve"
                          [(ngModel)]="approveCheck" value='true' class="form-check-input">
                        <label for="approveYes">Approve</label>
                      </div>
                      <div class="md-radio md-radio-inline">
                        <input id="approveNo" type="radio" style="position:absolute" name=" approve"
                          [(ngModel)]="approveCheck" value='false' class="form-check-input">
                        <label for="approveNo">Reject</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row"></div>
                <div class="row" *ngIf="approveCheck == 'false'">
                  <div class="col-sm-6">
                    Comment:
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <textarea class="form-control" [(ngModel)]="taskRejectComment"></textarea>
                    </div>
                  </div>
                </div>
                <div class="row"
                  *ngIf="approveCheck == 'true' && (saveType == 'addAndActivate' || saveType == 'updateAndActivate')">
                  <div class="col-sm-6">
                    Task Particulars:
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <textarea class="form-control" [(ngModel)]="taskParticulars"></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" (click)="approveTask()"
                  *ngIf="approveBtnType == 'single'">
                  <i class="fa fa-check"></i>Save
                </button>
                <button type="button" class="btn btn-sm btn-primary" (click)="approveMultipleTasks()"
                  *ngIf="approveBtnType == 'multi'">
                  <i class="fa fa-check"></i>Save
                </button>
                <button type="button" class="btn btn-sm" data-dismiss="modal">
                  <i class="fa fa-times"></i>Cancel
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>

<!-- Bulk Upload Modal -->
<div class="modal" id="bulkUploadModal" tabindex="-1" role="dialog" aria-labelledby="bulkUploadModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="bulkUploadModalLabel">
          <i class="fa fa-upload"></i> Bulk Upload Tasks
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="bulk-upload-container">
          
          <!-- Instructions Section -->
          <div class="alert alert-info">
            <h6><i class="fa fa-info-circle"></i> Instructions:</h6>
            <ol>
              <li>Download the Excel template using the button below</li>
              <li>Fill in all required fields for each task</li>
              <li>Upload the completed Excel file</li>
              <li>Review any errors and fix them before final submission</li>
            </ol>
          </div>

          <!-- Template Download Section -->
          <div class="template-section">
            <h6><i class="fa fa-download"></i> Step 1: Download Template</h6>
            <button type="button" class="btn btn-primary" (click)="downloadBulkUploadTemplate()">
              <i class="fa fa-file-excel-o"></i> Download Excel Template
            </button>
            <p class="text-muted mt-2">
              <small>The template contains all required columns with sample data and instructions.</small>
            </p>
          </div>

          <hr>

          <!-- File Upload Section -->
          <div class="upload-section">
            <h6><i class="fa fa-upload"></i> Step 2: Upload Completed File</h6>
            <div class="form-group">
              <label for="bulkUploadFile">Select Excel File:</label>
              <input type="file" 
                     id="bulkUploadFile" 
                     class="form-control-file" 
                     accept=".xlsx,.xls"
                     (change)="onBulkUploadFileSelected($event)">
              <small class="text-muted">Accepted formats: .xlsx, .xls</small>
            </div>
            
            <div *ngIf="selectedBulkFile" class="alert alert-success">
              <i class="fa fa-check-circle"></i> File selected: <strong>{{ selectedBulkFile.name }}</strong>
            </div>
          </div>

          <hr>

          <!-- Preview/Validation Section -->
          <div *ngIf="bulkUploadPreviewData && bulkUploadPreviewData.length > 0" class="preview-section">
            <h6><i class="fa fa-eye"></i> Step 3: Preview & Validate</h6>
            
            <div class="alert alert-warning" *ngIf="bulkUploadErrors && bulkUploadErrors.length > 0">
              <h6><i class="fa fa-exclamation-triangle"></i> Validation Errors Found:</h6>
              <ul>
                <li *ngFor="let error of bulkUploadErrors">{{ error }}</li>
              </ul>
              <p class="mb-0"><strong>Please fix these errors before uploading.</strong></p>
            </div>

            <div class="alert alert-success" *ngIf="(!bulkUploadErrors || bulkUploadErrors.length === 0) && bulkUploadPreviewData.length > 0">
              <i class="fa fa-check-circle"></i> <strong>{{ bulkUploadPreviewData.length }}</strong> tasks validated successfully and ready to upload!
            </div>

            <div class="table-responsive" style="max-height: 300px; overflow-y: auto;">
              <table class="table table-sm table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th>#</th>
                    <th>Task Name</th>
                    <th>Description</th>
                    <th>Tag</th>
                    <th>Trigger Type</th>
                    <th>Trigger Name</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let task of bulkUploadPreviewData; let i = index" 
                      [ngClass]="{'table-danger': task.hasError, 'table-success': !task.hasError}">
                    <td>{{ i + 1 }}</td>
                    <td>{{ task.TaskName || 'N/A' }}</td>
                    <td>{{ task.TaskDescription || 'N/A' }}</td>
                    <td>{{ task.Tag || 'N/A' }}</td>
                    <td>{{ task.TriggerType || 'N/A' }}</td>
                    <td>{{ task.TriggerName || 'N/A' }}</td>
                    <td>
                      <span *ngIf="!task.hasError" class="badge badge-success">Valid</span>
                      <span *ngIf="task.hasError" class="badge badge-danger">Error</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
      <div class="modal-footer">
        <button type="button" 
                class="btn btn-success" 
                (click)="processBulkUpload()"
                [disabled]="!selectedBulkFile || !bulkUploadPreviewData || bulkUploadPreviewData.length === 0 || (bulkUploadErrors && bulkUploadErrors.length > 0) || isBulkUploading">
          <i class="fa fa-upload" *ngIf="!isBulkUploading"></i>
          <i class="fa fa-spinner fa-spin" *ngIf="isBulkUploading"></i>
          {{ isBulkUploading ? 'Uploading...' : 'Upload Tasks' }}
        </button>
        <button type="button" class="btn btn-secondary" (click)="resetBulkUpload()" [disabled]="isBulkUploading">
          <i class="fa fa-times"></i> Close
        </button>
      </div>
    </div>
  </div>
</div>

<app-alert></app-alert>